import React from 'react'
import styled, { css, RuleSet } from 'styled-components'
import getPalette from '../../helpers/colors/colors'
import getFont from '../../helpers/fonts/fonts'

const palette = getPalette()

interface IMainButtonProps {
	text: string
	isDisabled?: boolean
	isRounded?: boolean
	onSubmit?: (ev: React.FormEvent) => void
	backgroundColor?: string
	Icon?: React.ReactNode
	customCss?: RuleSet<object>
}
const disabledButtonColor = '#BCE9FF'

const minWidthCss = css`
	@media (min-width: 600px) {
		min-width: 100px;
		min-height: 28px;
	}
	@media (min-width: 850px) {
		min-width: 120px;
		min-height: 32px;
	}
	@media (min-width: 1400px) {
		min-width: 132px;
		padding: 2px 16px;
	}
	@media (min-width: 1500px) {
		min-width: 140px;
		min-height: 40px;
	}
`

const StyledButton = styled.button<{ $customCss?: RuleSet<object> }>`
	padding: 2px 8px;
	border: none;
	color: rgb(255, 255, 255);
	cursor: pointer;
	font-size: inherit;
	display: flex;
	align-items: center;
	justify-content: space-evenly;

	&.rounded {
		border-radius: 4px;
	}

	&.disabled {
		color: #ffffff;
		cursor: default;
	}
	${(props) => (props.$customCss ? props.$customCss : minWidthCss)}
`
const StyledDiv = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-evenly;
	width: 100%;

	& > svg {
		display: none;

		@media (min-width: ${600}px) {
			display: block;
			margin-right: 4px;
			max-width: 15px;
			width: fit-content;
		}
	}
`
const StyledSpan = styled.span`
	padding-top: 1px;
`

const MainButton = (props: IMainButtonProps) => {
	let className = ''
	className += props.isRounded ? ' rounded' : ''
	className += props.isDisabled ? ' disabled' : ''

	const backgroundColor = props.isDisabled ? disabledButtonColor : props.backgroundColor || palette.blue

	return (
		<StyledButton
			style={{
				fontFamily: getFont('mainButton'),
				backgroundColor,
			}}
			disabled={props.isDisabled}
			onClick={props.onSubmit}
			type='button'
			className={className}
			$customCss={props.customCss || undefined}
		>
			<StyledDiv>
				{props.Icon}
				<StyledSpan>{props.text}</StyledSpan>
			</StyledDiv>
		</StyledButton>
	)
}

export default MainButton
